import { isBriefingPdfSnapshot } from "@/lib/briefing/briefingUtils";

const GA_MEASUREMENT_ID = "G-DWBS59VVDF";

let bootstrapped = false;

/**
 * Loads GA4 via gtag.js without inline HTML scripts (CSP-friendly bundled bootstrap).
 * Skips init on Gotenberg briefing PDF snapshots (`?print=1`).
 */
export const bootstrapGoogleTag = (): void => {
  if (
    bootstrapped ||
    typeof window === "undefined" ||
    isBriefingPdfSnapshot()
  ) {
    return;
  }

  bootstrapped = true;
  window.dataLayer = window.dataLayer ?? [];

  window.gtag = function gtag() {
    // biome-ignore lint/complexity/noArguments: gtag bootstrap must push the Arguments object, not a rest array
    window.dataLayer?.push(arguments);
  } as Window["gtag"];

  window.gtag?.("js", new Date());
  window.gtag?.("config", GA_MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};
